<template>
    <div class="w-full flex">
        <div
            ref="menuLeftContainer"
            class="shrink-0 flex"
            :style="menuContainerStyle"
        >
            <div ref="menuLeftContent">
                <slot name="left" />
            </div>
        </div>
        <div class="flex-1">
            <slot />
        </div>
        <div
            ref="menuRightContainer"
            class="shrink-0 flex"
            :style="menuContainerStyle"
        >
            <div ref="menuRightContent">
                <slot name="right" />
            </div>
        </div>
    </div>
</template>

<script setup>
    const emit = defineEmits(['update:sideWidth'])

    const props = defineProps({
        enabled: {
            type: Boolean,
            default: true,
        },
    })

    const menuLeftContent = useTemplateRef('menuLeftContent')
    const menuRightContent = useTemplateRef('menuRightContent')

    const { width: menuLeftWidth } = useElementSize(menuLeftContent)
    const { width: menuRightWidth } = useElementSize(menuRightContent)

    const menuSidesWidth = computed(() => {
        return Math.max(menuLeftWidth.value, menuRightWidth.value)
    })

    const menuContainerStyle = computed(() => {
        return props.enabled
            ? { minWidth: `${menuSidesWidth.value}px` }
            : {}
    })

    watch(menuSidesWidth, (newWidth) => {
        emit('update:sideWidth', newWidth)
    }, { immediate: true })
</script>
